import {gql} from "@apollo/client";
import {ProductFragmentQL} from "./products.service";

export const DeliveryProviderFragmentQL = gql`
fragment DeliveryProviderFragment on DeliveryProvider {
    _id
    isActive
    type
    interface {
        _id
        label
    }
}
`;

export const PickUpLocationFragmentQL = gql`
fragment PickUpLocationFragment on PickUpLocation {
    _id
    name
    orderlyIsAvailable
}
`;

export const OrderDeliveryFragmentQL = gql`
fragment OrderDeliveryFragment on OrderDelivery {
    _id
    ... on OrderDeliveryPickUp {
        pickUpLocations {
            ...PickUpLocationFragment
        }
        activePickUpLocation {
            ...PickUpLocationFragment
        }
    }
    provider {
        ...DeliveryProviderFragment
    }
}
${DeliveryProviderFragmentQL}
${PickUpLocationFragmentQL}
`;

export const OrderlySectorFragmentQL = gql`
fragment OrderlySectorFragment on OrderlySector {
    _id
    title
    subtitle
    isActive
    isSameDayPreOrderEnabled
    isThirdSeatFieldEnabled
    kitchenClosureTime
    kitchenOpeningTime
    timeToAutoCloseSeconds
    timeToDeliverySeconds
    assortmentSettings
    supportedDeliveryProviders {
        ...DeliveryProviderFragment
    }
    reservationHours: preOrderOpeningHours
}
${DeliveryProviderFragmentQL}
`;

export const PaymentProviderFragmentQL = gql`
fragment PaymentProviderFragment on PaymentProvider {
    _id
    type
    interface{_id label}
    isActive
}
`;

export const OrderItemFragmentQL = gql`
fragment OrderItemFragment on OrderItem {
    _id
    quantity
    product {
        ...ProductFragment
    }
    orderlyOptions {
        ...ProductFragment 
    }
    discount: total(category: DISCOUNT) {
        amount
        currencyCode
    }
    total {
        amount
        currencyCode    
    }
}
${ProductFragmentQL}
`;


export const OrderlyGeoLocationFragmentQL = gql`
fragment OrderlyGeoLocationFragment on OrderlyGeoLocation {
    accuracy 
    latitude
    longitude
}
`;


export const CartFragmentQL = gql`
fragment CartFragment on Order {
    _id
    orderlySeatNumber
    contact {telNumber}
    orderlyReservationDate
    orderlyGeoLocation {
        ...OrderlyGeoLocationFragment
    }
    items {
        ...OrderItemFragment
    }
    discounts {
        interface { 
            _id
            label
        }
        total {
            amount 
            currencyCode        
        }    
    }
    deliveryTotal: total(category: DELIVERY) {
        amount
        currencyCode
    }
    goods: total(category: ITEMS) {
        amount
        currencyCode
    }
    paymentTotal: total(category: PAYMENT) { 
        amount 
        currencyCode
    }
    total {
        amount
        currencyCode
    }
    delivery {
        ...OrderDeliveryFragment
    }
    supportedPaymentProviders {
        ...PaymentProviderFragment        
    }
}
${OrderItemFragmentQL}
${OrderDeliveryFragmentQL}
${PaymentProviderFragmentQL}
${OrderlyGeoLocationFragmentQL}
`;


export const CreatedOrderFragmentQL = gql`
fragment CreatedOrderFragment on Order {
    ...CartFragment    
    orderNumber
    ordered
    status
    orderlyRejectReason
    orderlyIsReservationConfirmed
}
${CartFragmentQL}
`;

